"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapToString = exports.mapToNumber = void 0;
/**
 * @internal
 */
function mapToNumber(value) {
    // Cast to number
    var number = Number(value);
    if (!isNaN(number)) {
        // Could be casted, assign
        return number;
    }
    else {
        throw new Error("Can't be casted to number");
    }
}
exports.mapToNumber = mapToNumber;
/**
 * @internal
 */
function mapToString(value) {
    // Depending on the type we prefer to do `String` or `stringify`
    var isToString = ['string', 'symbol', 'bigint', 'function'].includes(typeof value) || value instanceof Error;
    if (isToString) {
        try {
            return String(value);
        }
        catch (_a) {
            return JSON.stringify(value);
        }
    }
    else {
        try {
            return JSON.stringify(value);
        }
        catch (_b) {
            return String(value);
        }
    }
}
exports.mapToString = mapToString;
